export default __webpack_public_path__ + "static/media/login_staff_dox.4426e112.png";